var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "12.47 85.33 182.09 99.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.679 111.503l-4.536-1.323-.567 1.512 4.536 1.323s-1.512 2.457-2.08 4.725c-.566 2.267-.283-3.308-.283-3.308h-1.795l.567 5.575-6.048 5.009.378 2.929 5.953-5.292s-.945 8.694.756 12.379c1.701 3.685-2.268 7.087-2.268 7.087l-1.795-1.323-.094 1.701 3.401 3.024-.567 6.614 1.607.095.189-6.048s3.874.284 5.008 3.213c1.134 2.93 4.252 6.237 4.252 6.237l1.89 8.032 1.984.472-1.795-6.52s10.678 9.45 15.97 11.717c5.291 2.268 2.173 2.363 2.173 2.363l.094 1.323 3.875-.756s10.11 4.535 15.024 4.535 3.024 1.418 3.024 1.418l1.134 2.362 13.04-4.441s16.253.661 25.891-.662c9.639-1.322 9.639.756 9.639.756h1.89l-.662-1.323 9.072-.472-9.166 8.504 1.04 1.607 11.433-10.583s14.647 1.133 20.033-2.835c5.386-3.969-2.08 4.157-2.08 4.157l1.135.567 3.685-4.724s7.465-.945 10.867-3.686c3.402-2.74 3.307-1.133 3.307-1.133s2.74 3.118 4.158-5.009c1.417-8.126 4.441-5.008 4.441-5.008l1.134 5.386 1.417-.378-1.417-5.197s2.362-.661 2.457-1.417c.094-.756 5.292-2.363 5.292-2.363v-1.039l-3.308.756v-1.512h1.701l-.094-1.417 1.89.85.472-.945-1.795-1.228s1.134-3.875.378-4.63c-.756-.756 3.307-.095 3.307-.095l.567 4.158 1.323-.095-1.701-12.473 2.551-.945v-1.417s-3.213 2.74-3.59-3.402c-.379-6.142.944-5.859.944-5.859l-.567-1.512-1.228 1.229s-1.7-2.74 0-7.276-11.15-14.552-12.284-14.836c-1.134-.283 6.614-1.04 6.614-1.04l.19-1.795-8.6 1.229 2.93-5.953-.945-1.418-3.591 6.993s-8.977-3.686-14.836-4.252c-5.858-.567-5.953-5.292-5.953-5.292h-1.323s1.701 3.685 1.229 4.725c-.473 1.039-4.914-2.174-4.914-2.174s-.283-3.969-.945-5.197c-.661-1.228-2.646-1.134-2.646-1.134s2.646 2.551 1.796 7.56c-.85 5.008-25.986-3.686-25.986-3.686l-1.229 1.607s-32.222-4.441-53.2 1.606c-20.977 6.048-24.852 8.127-25.986 7.843-1.133-.283 2.08-2.551 2.08-2.551l-.757-1.134-3.496 3.874s-2.74.662-3.118 1.04c-.378.378-5.859-4.253-5.859-4.253l-.85 1.985s3.307 2.646 3.496 3.59c.189.945-5.859 1.229-9.26 8.694z",
    fill: "#264653"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M72.752 90.781c-11.33.113-14.956 20.055-14.956 20.055a17.334 17.334 0 00-.169 4.38c4.563.889 18.908 3.775 25.892 6.251a27.628 27.628 0 002.073-3.682c4.276-9.088-.535-26.46-12.295-26.995a9.83 9.83 0 00-.545-.009z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "#f4a261"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.818 107.762h9.02v6.147h-9.02z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M84.923 99.61c-1.737 6.281-10.824 5.613-10.824 5.613l-.802 4.944-1.737 1.203-1.07-1.069-.534-4.677c-5.479 1.737-8.953-5.345-8.953-5.345s-3.993 7.407-3.646 14.883c4.421.859 19.782 3.935 26.655 6.486 7.288-9.277.911-22.038.911-22.038z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M120.237 96.502c-.53-.006-1.069.026-1.616.096-11.676 1.5-11.815 22.417-11.815 22.417.05 4.214 1.478 7.543 3.5 10.043 6.262-.921 16.11-2.445 23.66-3.978a27.605 27.605 0 001.419-4.01c2.521-9.235-4.386-24.46-15.148-24.568z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "#f4a261"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.15 114.26l8.885-1.555 1.06 6.056-8.886 1.554z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M131.594 103.282c-.63 6.486-9.695 7.394-9.695 7.394l.062 5.009-1.504 1.484-1.237-.869-1.333-4.515c-5.098 2.656-9.74-3.722-9.74-3.722s-4.36 13.099 1.516 21.09c6.383-.933 17.085-2.579 24.939-4.204 5.367-10.341-3.008-21.667-3.008-21.667z",
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "#000001"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.065 107.723s.378 4.347 4.536 5.48c4.158 1.135 39.499 4.159 47.814 13.419 8.316 9.26 52.35-5.103 52.35-5.103s26.647-10.016-1.323-18.71",
    fill: "none",
    stroke: "#2a9d8f",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      lineHeight: 1.25
    },
    x: 54.24,
    y: 154.403,
    fontWeight: 400,
    fontSize: 19.756,
    fontFamily: "sans-serif",
    letterSpacing: 0,
    wordSpacing: 0,
    strokeWidth: 0.265
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 54.24,
    y: 154.403,
    style: {
      InkscapeFontSpecification: "'Roboto Bold'"
    },
    fontWeight: 700,
    fontFamily: "Roboto",
    fill: "#fff"
  }, "Legal Nest")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.31782d6b.svg";
export { ForwardRef as ReactComponent };